import { neutral300, neutral50, neutral500 } from '@fever/ui';
import React from 'react';
import { Global, css } from '@emotion/core';
import { BUILD_ID, IS_LIVE_PROD } from 'config/envVariable';

const hash = BUILD_ID ? `?${BUILD_ID}` : '';
// prod 走正式路徑，其餘環境（dev/stage/local）都走 /dev/ 子路徑。
const iconFontPath = IS_LIVE_PROD ? 'icon-font' : 'dev/icon-font';

function GlobalCss() {
    return (
        <Global
            styles={css`
                @import url('https://utility.fevercdn.com/${iconFontPath}/fever-icon-font.css.gz${hash}');

                body {
                    margin: 0;
                    font-family: 'Lato', 'Roboto', 'Arial', 'Source Han Sans TC', 'Droid Sans',
                        'Noto Sans CJK TC', 'Noto Sans TC', 'Microsoft JhengHei', '微軟正黑體',
                        '微軟正黑體', 'Microsoft YaHei', 'Hiragino Sans GB', 'sans-serif';
                    -webkit-font-smoothing: antialiased;
                    -moz-osx-font-smoothing: grayscale;
                }

                html,
                body,
                #root {
                    height: 100%;
                    width: 100%;
                }

                * {
                    box-sizing: border-box;
                }

                // scrollbar custom css
                .ScrollbarsCustom-Track {
                    background: ${neutral50} !important;
                    border-radius: 4px !important;
                }

                .ScrollbarsCustom-Thumb {
                    background: ${neutral300} !important;
                    border-radius: 4px !important;
                    &:hover {
                        background: ${neutral500} !important;
                    }
                }

                /* Mui Global Css */
                .MuiButtonBase-root.Mui-disabled,
                .MuiSelect-select.Mui-disabled,
                .MuiInputBase-input.Mui-disabled {
                    cursor: not-allowed;
                }
                .MuiButtonBase-root.Mui-disabled {
                    pointer-events: initial;
                }
            `}
        />
    );
}

export default GlobalCss;
